import DEFAULT from './default.svg';
import SCAN_CODE from './scan-code.svg';

export const EMPTY_IMG = {
  DEFAULT,
  SCAN_CODE,
} as const;
